export const ExperienceCustomMetricDtoDescriptions = {
  id: "Server-generated. Read-only.",
  experienceId: "References the parent experience.",
  order: "Display position in the analytics dashboard. 0-indexed.",
  customEventId:
    "References the custom event definition configured in the organization's analytics settings.",
  customEvent:
    "Server-generated. Read-only. Expanded custom event definition with name, tracking details, and configuration.",
} as const;

export const CreateExperienceCustomMetricDtoDescriptions = {
  experienceId:
    "Omit when creating as part of a new experience -- auto-assigned from parent.",
} as const;
